import { PrismicRichText } from '@prismicio/react';
import { FC, ReactNode } from 'react';
import { RichTextField } from '@prismicio/client';

interface StatItemProps {
  item: Record<string, unknown>;
}

const renderContent = (content: unknown, className: string): ReactNode => {
  if (Array.isArray(content) && content.length > 0) {
    return (
      <PrismicRichText
        field={content as RichTextField}
        components={{
          heading1: ({ children }) => (
            <div className={className}>{children}</div>
          ),
          heading2: ({ children }) => (
            <div className={className}>{children}</div>
          ),
          paragraph: ({ children }) => (
            <div className={className}>{children}</div>
          ),
        }}
      />
    );
  }
  if (content) {
    return <div className={className}>{String(content)}</div>;
  }
  return null;
};

const StatItem: FC<StatItemProps> = ({ item }) => {
  const metric = item.metric;
  const metricLabel = item.metric_label;

  return (
    <div className="stat-item">
      {renderContent(
        metric,
        'text-[22px] md:text-[28px] font-extrabold text-white leading-none',
      )}
      {renderContent(metricLabel, 'mt-1 text-sm text-gray-200 text-center')}
    </div>
  );
};

export default StatItem;
